import React from 'react';
import PropTypes from 'prop-types';

import '../styles.scss';

const Button = ({ children, className, ...buttonProps }) => {
  let btnClassName = 'tertiary-button';

  if (className) {
    btnClassName = `${btnClassName} ${className}`;
  }

  return (
    <button type="button" className={btnClassName} {...buttonProps}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Button;
